/* Dependencies
 ---------------------------------------------------------- */
import { Application } from 'wrapper6'

/* Services
 ---------------------------------------------------------- */

/* Register services
 ---------------------------------------------------------- */

/* Modules
 ---------------------------------------------------------- */
import Navigation from './modules/_navigation'
import ObjectFit from './modules/_object-fit'
import Print from './modules/_print'
import ProductDescriptions from './modules/_product-descriptions'
import WoocommerceScroll from './modules/_woocommerce-scroll'
import AgeCheck from './modules/_agecheck'
import GA4TrackingHandler from './GA4/_ga4-tracking-handler'
import GA4TrackingUpdateCart from "./GA4/_ga4-tracking-update-cart";

/* Vendor
 ---------------------------------------------------------- */

/* Setup
 ---------------------------------------------------------- */
const app = window.app = new Application(window.options || {})

/* Register modules
 ---------------------------------------------------------- */
app.use(Navigation)
app.use(ObjectFit)
app.use(Print)
app.use(ProductDescriptions)
app.use(WoocommerceScroll)
app.use(AgeCheck)
app.use(GA4TrackingUpdateCart)
app.use(GA4TrackingHandler)

require('./app')
